<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('route.users')}}</el-breadcrumb-item>
    </el-breadcrumb>

    <h2 class="page-title"> {{$t('entities.user.plural')}} </h2>

    <el-row :gutter="20">
      <el-col :xs="24" :md="8">

        <el-form @submit.native.prevent class="search" :inline="true">
          <el-form-item>
            <el-input v-model="pager.search" :placeholder="$t('table.search')">
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>

      <el-col class="button-group" :xs="24" :md="16">
        <el-button
          v-if="hasRoleToCreate"
          icon="el-icon-fa-file-o"
          @click="create()"
          type="primary"
        > {{$t('table.add')}}
        </el-button>

      <!-- ADD PROPERTY -->

      <el-button 
      icon="el-icon-circle-plus-outline"
      type="primary"
      @click="vOpenDialog = true"
      >
      {{$t('table.addProperty')}}
      </el-button>

      <el-dialog
        title="Asignar property a todos"
        :visible.sync="vOpenDialog"
        width="30%"
        center>
        <span slot="footer" class="dialog-footer">
           <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                    <el-input v-model="form.property" placeholder="Nombre de la property"></el-input>
                    <!-- <el-input v-model="form.key" placeholder="Nombre del valor"></el-input> -->
                </el-form-item>
            </el-form>
          <el-button @click="vOpenDialog = false">{{$t('table.cancel')}}</el-button>
          <el-button type="primary" @click="addProperty"> {{$t('table.confirm')}}</el-button>
        </span>
      </el-dialog>

        <!-- <el-button
          v-if="hasRoleToCreate"
          icon="el-icon-circle-plus-outline"
          @click="addProperty()"
          type="primary"
        > {{$t('table.addProperty')}}


        </el-button> -->

               



        <el-button icon="el-icon-fa-history" @click="history()" type="infor"> {{$t('table.history')}}</el-button>
      </el-col>


    </el-row>

    <el-table
      :data="pager.paginate(list)"
      :default-sort="{
        prop: 'email',
        order: 'ascending'
      }"
      empty-text="There are no users yet"
      @sort-change="(args) => pager.sortChange(args)"
      style="width: 100%"
      v-loading="loading"
      border
    >
      <el-table-column prop="email" label="Email" sortable="custom"></el-table-column>

      <el-table-column prop="roles" label="Roles">
        <template slot-scope="scope">
          <div v-for="role in scope.row.roles" :key="role">{{ roleLabel(role) }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="created" label="Created At" sortable="custom">
        <template slot-scope="scope">{{ scope.row.created | formatDatetime }}</template>
      </el-table-column>

      <el-table-column
        :fixed="isMobile? undefined : 'right'"
        label="Operations"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-tooltip content="Details" placement="top">
            <el-button
              icon="el-icon-fa-search"
              size="small"
              type="text"
              @click="show(scope.row.id)"
            />
          </el-tooltip>

          <el-tooltip v-if="hasRoleToUpdate" :content="$t('table.edit')" placement="top">
            <el-button
              icon="el-icon-fa-pencil-square-o"
              size="small"
              type="text"
              @click="edit(scope.row.id)"
            />
          </el-tooltip>

          <el-tooltip content="Activity" placement="top">
            <el-button
              icon="el-icon-fa-eye"
              size="small"
              type="text"
              @click="viewActivity(scope.row.id)"
            />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="mt-3">
      <el-pagination
        style="float: right"
        @size-change="(args) => pager.pageSizeChange(args)"
        :current-page.sync="pager.currentPage"
        :layout="paginationLayout"
        :total="pager.filteredAndSortedList(list).length"
        background
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Roles from "@/auth/roles";

export default {
  name: "app-user-list",

  computed: {
    ...mapGetters({
      loading: "user/loading",
      list: "user/list",
      pager: "user/pager",
      hasRoleToCreate: "user/hasRoleToCreate",
      hasRoleToUpdate: "user/hasRoleToUpdate",
      isMobile: "shared/isMobile",
      paginationLayout: "shared/paginationLayout"
    })
  },

  data() {
    return {
      vOpenDialog: false,
      form: {
        property: '',
        // key: ''
      },
    }
  },
  created() {
    this.$store.dispatch("user/list");
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  },

  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("user/list");
    next();
  },

  methods: {
    create() {
      this.$router.push({
        name: "userNew"
      });
    },

    addProperty() {
      if (this.form.property !== "") {
        this.$store.dispatch("user/addProperty", this.form.property).then(() => {
          // Reseteamos los datos
          this.form.property = ''
          this.vOpenDialog = false
        });
      }
    },

    show(id) {
      this.$router.push({
        name: "userShow",
        params: { id }
      });
    },

    edit(id) {
      this.$router.push({
        name: "userEdit",
        params: { id }
      });
    },

    viewActivity(id) {
      this.$router.push({
        name: "userActivity",
        params: { id }
      });
    },

    roleLabel(roleId) {
      return Roles.labelOf(roleId);
    },

    history() {
      this.$router.push({ name: "userHistoryFull" });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/user/user-list.vue?c0a01038